import { Input } from "reactstrap";
import { MainContainer } from "../MainContainer";

type Props = {
    setSelectedWallet: (value: string) => void;
    selectedWallet: string;
};

 // Função para renderizar o componente de seleção de carteira ou não
export const SelecioneCarteiraOuNao = (props:Props) => {

    return (
      <MainContainer>
        <div className='d-flex flex-column gap-4'>
          <div style={{ fontSize: '1.25rem ', fontWeight: '700 ', color: '#000' }}>Selecione o tipo de cohort</div>
          <Input type="select" className='w-50' onChange={(e) => props.setSelectedWallet(e.target.value)} value={props.selectedWallet}>
            <option value="">Selecione</option>
            <option value="true">Clientes Carteira</option>
            <option value="false">Clientes Não Carteira</option>
          </Input>
        </div>
      </MainContainer>
    );
  }